export default __webpack_public_path__ + "static/media/slider-unraf-6.7b889667.jpg";